import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
    name: 'mibDateTime',
    standalone: false
})
export class MibTimeDatePipe extends
    DatePipe implements PipeTransform {
    override transform(value: any, args?: any): any {
        return super.transform(value, "yyyy-MM-dd hh:mm:ss");
    }
}